/*
 * Dynamic PDP delivery estimate.
 *
 * Logic (calibrated 2026-05-16 from supplier feedback - see ADR 0012):
 *   - Order cutoff: 10:00 CEST (shop TZ). Before cutoff on a DK business
 *     day = "today's order". After = next DK business day.
 *   - Monday is a backlog day: weekend orders are processed first, so
 *     even Monday orders placed before cutoff get +1 extra procurement day.
 *   - Procurement: +3 business days where ALL of {DK, DE, NL} are open.
 *     We can't receive goods if supplier is closed OR we're closed.
 *   - Carrier: +1-2 business days from procurement end, DK calendar only
 *     (PostNord/GLS/DAO don't deliver weekends/DK holidays).
 *
 * Holiday arrays are static and need yearly refresh - 2026 + 2027 included.
 * NL Bevrijdingsdag (May 5) is only a public holiday in lustrum years
 * (every 5 years - 2025 was; 2030 is next) so excluded for 2026/27.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var HOLIDAYS = {
    dk: [
      // 2026
      '2026-01-01', '2026-04-02', '2026-04-03', '2026-04-06',
      '2026-05-14', '2026-05-25', '2026-06-05',
      '2026-12-24', '2026-12-25', '2026-12-26', '2026-12-31',
      // 2027
      '2027-01-01', '2027-03-25', '2027-03-26', '2027-03-29',
      '2027-05-06', '2027-05-17', '2027-06-05',
      '2027-12-24', '2027-12-25', '2027-12-26', '2027-12-31'
    ],
    de: [
      // 2026
      '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-01',
      '2026-05-14', '2026-05-25', '2026-10-03',
      '2026-12-25', '2026-12-26',
      // 2027
      '2027-01-01', '2027-03-26', '2027-03-29', '2027-05-01',
      '2027-05-06', '2027-05-17', '2027-10-03',
      '2027-12-25', '2027-12-26'
    ],
    nl: [
      // 2026
      '2026-01-01', '2026-04-03', '2026-04-06', '2026-04-27',
      '2026-05-14', '2026-05-25',
      '2026-12-25', '2026-12-26',
      // 2027
      '2027-01-01', '2027-03-26', '2027-03-29', '2027-04-27',
      '2027-05-06', '2027-05-17',
      '2027-12-25', '2027-12-26'
    ]
  };

  var CUTOFF_HOUR = 10;
  var CUTOFF_MIN = 0;
  var PROCUREMENT_DAYS = 3;
  var MONDAY_PROCUREMENT_PENALTY = 1; // weekend backlog buffer
  var CARRIER_MIN = 1;
  var CARRIER_MAX = 2;

  var DA_DAYS = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];
  var DA_MONTHS = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function toISO(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function isWeekend(d) { var day = d.getDay(); return day === 0 || day === 6; }
  function isHoliday(d, calendars) {
    var iso = toISO(d);
    for (var i = 0; i < calendars.length; i++) {
      if (HOLIDAYS[calendars[i]].indexOf(iso) !== -1) return true;
    }
    return false;
  }
  function isBusinessDay(d, calendars) {
    return !isWeekend(d) && !isHoliday(d, calendars);
  }
  function addBusinessDays(date, days, calendars) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var added = 0;
    var guard = 0;
    while (added < days && guard < 365) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result, calendars)) added++;
      guard++;
    }
    return result;
  }
  function nextBusinessDay(date, calendars) {
    return addBusinessDays(date, 1, calendars);
  }

  function getProcessingStart(now) {
    var cutoffToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, CUTOFF_MIN, 0, 0);
    if (now < cutoffToday && isBusinessDay(now, ['dk'])) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
    return nextBusinessDay(now, ['dk']);
  }

  function estimate(now) {
    var start = getProcessingStart(now);
    // Monday-special: weekend orders pile up, so Mondays get +1 procurement
    // day (regardless of whether order was placed before cutoff).
    var procurementDays = PROCUREMENT_DAYS;
    if (start.getDay() === 1) {
      procurementDays += MONDAY_PROCUREMENT_PENALTY;
    }
    var procurementEnd = addBusinessDays(start, procurementDays, ['dk', 'de', 'nl']);
    var earliest = addBusinessDays(procurementEnd, CARRIER_MIN, ['dk']);
    var latest = addBusinessDays(procurementEnd, CARRIER_MAX, ['dk']);
    var cutoffToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), CUTOFF_HOUR, CUTOFF_MIN, 0, 0);
    var beforeCutoff = now < cutoffToday && isBusinessDay(now, ['dk']);
    return { earliest: earliest, latest: latest, beforeCutoff: beforeCutoff };
  }

  // stock:own (JA TAK): varen ligger på egen hylde. Bestilt før 12:00 på en
  // DK-hverdag sendes samme dag, ellers næste hverdag; levering = næste
  // hverdag efter afsendelse (DK-kalender, weekender og helligdage springes over).
  // Julefrist for eget lager (forslag 21/12) afventer orbit - ikke implementeret.
  var EGET_CUTOFF_HOUR = 12;

  function estimateEget(now) {
    var cutoffToday = new Date(now.getFullYear(), now.getMonth(), now.getDate(), EGET_CUTOFF_HOUR, 0, 0, 0);
    var beforeCutoff = now < cutoffToday && isBusinessDay(now, ['dk']);
    var ship = beforeCutoff
      ? new Date(now.getFullYear(), now.getMonth(), now.getDate())
      : nextBusinessDay(now, ['dk']);
    return { delivery: nextBusinessDay(ship, ['dk']), beforeCutoff: beforeCutoff };
  }

  function formatDate(d) {
    return DA_DAYS[d.getDay()] + ' ' + d.getDate() + '. ' + DA_MONTHS[d.getMonth()];
  }

  function formatRange(earliest, latest) {
    var sameMonth = earliest.getMonth() === latest.getMonth() && earliest.getFullYear() === latest.getFullYear();
    if (sameMonth) {
      return DA_DAYS[earliest.getDay()] + ' ' + earliest.getDate() + '. - ' +
        DA_DAYS[latest.getDay()] + ' ' + latest.getDate() + '. ' + DA_MONTHS[latest.getMonth()];
    }
    return DA_DAYS[earliest.getDay()] + ' ' + earliest.getDate() + '. ' + DA_MONTHS[earliest.getMonth()] +
      ' - ' + DA_DAYS[latest.getDay()] + ' ' + latest.getDate() + '. ' + DA_MONTHS[latest.getMonth()];
  }

  function render(node) {
    var now = new Date();
    if (node.dataset.eget === 'true') {
      var eg = estimateEget(now);
      var egTmpl = eg.beforeCutoff ? node.dataset.tmplEgetBefore : node.dataset.tmplEgetAfter;
      var egEl = node.querySelector('.pdp-delivery-estimate__text');
      if (egTmpl && egEl) egEl.innerHTML = egTmpl.replace('__RANGE__', formatDate(eg.delivery));
      return;
    }
    var est = estimate(now);
    var rangeText = formatRange(est.earliest, est.latest);
    var tmpl = est.beforeCutoff ? node.dataset.tmplBefore : node.dataset.tmplAfter;
    if (!tmpl) return;
    var textEl = node.querySelector('.pdp-delivery-estimate__text');
    if (textEl) textEl.innerHTML = tmpl.replace('__RANGE__', rangeText);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-pdp-delivery-estimate]');
    if (!nodes.length) return;
    nodes.forEach(function (node) { render(node); });
    // Re-render every 60s so the line transitions across cutoff (10:00)
    // and across midnight without a page reload.
    setInterval(function () {
      nodes.forEach(function (node) { render(node); });
    }, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
